(() => {
  const MOBILE_QUERY = window.matchMedia('(max-width: 980px)');

  const initialiseFilters = (root = document) => {
    root.querySelectorAll('[data-lmu-collection-filters]').forEach((form) => {
      if (form.dataset.lmuFiltersReady === 'true') return;
      form.dataset.lmuFiltersReady = 'true';
      let submitTimer;

      const submitFilters = () => {
        window.clearTimeout(submitTimer);
        form.classList.add('is-loading');
        document.documentElement.classList.add('lmu-filters-loading');
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      };

      const prepareGroups = () => {
        form.querySelectorAll('.lmu-filter-group').forEach((group) => {
          const hasSelection = Boolean(group.querySelector('input:checked'));
          if (MOBILE_QUERY.matches && !hasSelection) group.removeAttribute('open');
          if (!MOBILE_QUERY.matches) group.setAttribute('open', '');
        });
      };

      prepareGroups();
      MOBILE_QUERY.addEventListener?.('change', prepareGroups);

      form.addEventListener('change', (event) => {
        if (!event.target.matches('input, select')) return;
        if (MOBILE_QUERY.matches) return;
        window.clearTimeout(submitTimer);
        submitTimer = window.setTimeout(submitFilters, 120);
      });
    });

    root.querySelectorAll('[data-lmu-filter-toggle]').forEach((button) => {
      if (button.dataset.lmuFilterToggleReady === 'true') return;
      const drawer = document.getElementById(button.getAttribute('aria-controls'));
      if (!drawer) return;

      const scope = drawer.closest('.lmu-collection-content');
      const backdrop = scope?.querySelector('.lmu-filter-backdrop');
      const closeButtons = scope?.querySelectorAll('[data-lmu-filter-close]') || [];

      const closeDrawer = () => {
        drawer.classList.remove('is-mobile-open');
        backdrop?.classList.remove('is-visible');
        document.body.classList.remove('lmu-filter-drawer-open');
        button.setAttribute('aria-expanded', 'false');
      };

      const openDrawer = () => {
        drawer.classList.add('is-mobile-open');
        backdrop?.classList.add('is-visible');
        document.body.classList.add('lmu-filter-drawer-open');
        button.setAttribute('aria-expanded', 'true');
        drawer.querySelector('.lmu-filter-close')?.focus();
      };

      button.dataset.lmuFilterToggleReady = 'true';
      button.addEventListener('click', openDrawer);
      closeButtons.forEach((closeButton) => closeButton.addEventListener('click', closeDrawer));
      window.addEventListener('resize', () => {
        if (!MOBILE_QUERY.matches) closeDrawer();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && drawer.classList.contains('is-mobile-open')) {
          closeDrawer();
          button.focus();
        }
      });
    });
  };

  initialiseFilters();
  document.addEventListener('shopify:section:load', (event) => initialiseFilters(event.target));

  window.addEventListener('pageshow', () => {
    document.documentElement.classList.remove('lmu-filters-loading');
    document.body.classList.remove('lmu-filter-drawer-open');
    document.querySelectorAll('[data-lmu-collection-filters].is-loading').forEach((form) => {
      form.classList.remove('is-loading');
    });
  });
})();
